import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ReitService as reitService} from '@/services/investments';

/**
 * A custom hook used to manage the deletion of a REIT (Real Estate Investment Trust) holding.
 * It utilizes a mutation function that deletes the specified holding and invalidates related cache queries upon success.
 *
 * @return {UseMutationResult} The mutation object containing methods and state for executing and tracking the status of the deletion operation.
 */
export default function useDeleteReitHolding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await reitService.deleteHolding(id)
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['reit_holdings'] }),
  });
}
